import { IJxtBookingOrganizer } from './types';

const JxtBookingOrganizer = ({ name }: IJxtBookingOrganizer) => {
  return (
    <div className="flex items-center gap-3 min-w-0 text-body-m text-neutral-140">
      <div className="h-6 w-5 flex shrink-0 items-center justify-center">
        <i className="fas fa-user fa-fw fa-lg text-neutral-60" />
      </div>
      <span className="truncate" title={name}>
        {name}
      </span>
    </div>
  );
};

export default JxtBookingOrganizer;
